import { render, staticRenderFns } from "./PhoneTelInput.vue?vue&type=template&id=052e683b&"
import script from "./PhoneTelInput.vue?vue&type=script&lang=js&"
export * from "./PhoneTelInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VuetifyPhoneInput: require('/var/app/components/Vuetify/PhoneInput.vue').default})
